import { useQuery } from 'react-query';

import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';
import { OwnerService } from '@/api';
import { adaptGetOwnerByIdQueryResponse } from '@/api/Owner/order/getOwnerById/adaptGetOwnerByIdQueryResponse';

export const useGetOwnerSummary = ({ ownerId }: { ownerId?: string }) => {
  const { pushErrors } = useToasts();

  const { data } = useQuery(
    ['clientDetails', ownerId],
    async () => {
      if (!ownerId) {
        return undefined;
      }

      const response = await OwnerService.getOwnerById({ ownerId });

      if (response.failure) {
        pushErrors(response.errors);

        return undefined;
      }

      return {
        adaptedOwner: adaptGetOwnerByIdQueryResponse(response.value),
        rawOwnerSummary: response.value,
      };
    },
    {
      suspense: true,
      staleTime: Infinity,
    },
  );

  return {
    ownerSummary: data?.adaptedOwner,
    rawOwnerSummary: data?.rawOwnerSummary,
  };
};
